// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"9a71986005a4d704dd214f7f7d7eed36","795":"8a4bbda9326d76392d6429ae4a33d608"}[chunkId] + ".js";
};